import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import classNames from 'classnames';
import { Modal, PrimaryButton, SecondaryButton } from '../../components';
import { FieldCheckbox } from '../../components';
import css from './FreelancerOnboardingModal.css';

const { func, bool } = PropTypes;

class FreelancerOnboardingModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dontShowAgain: false,
    };
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleCheckboxChange(e) {
    this.setState({ dontShowAgain: e.target.checked });
  }

  handleClose() {
    const { dontShowAgain } = this.state;
    const { onClose, onDismissPermanently } = this.props;

    if (dontShowAgain && onDismissPermanently) {
      onDismissPermanently();
    }
    onClose();
  }

  render() {
    const { isOpen, onManageDisableScrolling, intl } = this.props;
    const { dontShowAgain } = this.state;

    return (
      <Modal
        id="FreelancerOnboardingModal"
        isOpen={isOpen}
        onClose={this.handleClose}
        onManageDisableScrolling={onManageDisableScrolling}
        // containerClassName={css.modalContainer}
        usePortal
      >
        <div className={css.modalContent}>
          <h2 className={css.modalTitle}>
            <FormattedMessage id="FreelancerOnboardingModal.title" />
          </h2>

          <div className={css.scrollableContent}>
            {/* Section 1: First Impressions */}
            <div className={css.section}>
              <h3 className={css.sectionTitle}>
                <FormattedMessage id="FreelancerOnboardingModal.section1Title" />
              </h3>
              <ul className={css.tipList}>
                <li className={css.tipItem}>
                  <div className={css.tipContent}>
                    <strong className={css.tipLabel}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip1_1Label" />
                    </strong>
                    <span className={css.tipText}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip1_1Text" />
                    </span>
                  </div>
                </li>
                <li className={css.tipItem}>
                  <div className={css.tipContent}>
                    <strong className={css.tipLabel}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip1_2Label" />
                    </strong>
                    <span className={css.tipText}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip1_2Text" />
                    </span>
                  </div>
                </li>
                <li className={css.tipItem}>
                  <div className={css.tipContent}>
                    <strong className={css.tipLabel}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip1_3Label" />
                    </strong>
                    <span className={css.tipText}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip1_3Text" />
                    </span>
                  </div>
                </li>
              </ul>
            </div>

            {/* Section 2: Pricing */}
            <div className={css.section}>
              <h3 className={css.sectionTitle}>
                <FormattedMessage id="FreelancerOnboardingModal.section2Title" />
              </h3>
              <ul className={css.tipList}>
                <li className={css.tipItem}>
                  <div className={css.tipContent}>
                    <strong className={css.tipLabel}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip2_1Label" />
                    </strong>
                    <span className={css.tipText}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip2_1Text" />
                    </span>
                  </div>
                </li>
                <li className={css.tipItem}>
                  <div className={css.tipContent}>
                    <strong className={css.tipLabel}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip2_2Label" />
                    </strong>
                    <span className={css.tipText}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip2_2Text" />
                    </span>
                  </div>
                </li>
                <li className={css.tipItem}>
                  <div className={css.tipContent}>
                    <strong className={css.tipLabel}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip2_3Label" />
                    </strong>
                    <span className={css.tipText}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip2_3Text" />
                    </span>
                  </div>
                </li>
                <li className={css.tipItem}>
                  <div className={css.tipContent}>
                    <strong className={css.tipLabel}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip2_4Label" />
                    </strong>
                    <span className={css.tipText}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip2_4Text" />
                    </span>
                  </div>
                </li>
                <li className={css.tipItem}>
                  <div className={css.tipContent}>
                    <strong className={css.tipLabel}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip2_5Label" />
                    </strong>
                    <span className={css.tipText}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip2_5Text" />
                    </span>
                  </div>
                </li>
              </ul>
            </div>

            {/* Section 3: Clear Expectations */}
            <div className={css.section}>
              <h3 className={css.sectionTitle}>
                <FormattedMessage id="FreelancerOnboardingModal.section3Title" />
              </h3>
              <ul className={css.tipList}>
                <li className={css.tipItem}>
                  <div className={css.tipContent}>
                    <strong className={css.tipLabel}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip3_1Label" />
                    </strong>
                    <span className={css.tipText}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip3_1Text" />
                    </span>
                  </div>
                </li>
                <li className={css.tipItem}>
                  <div className={css.tipContent}>
                    <strong className={css.tipLabel}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip3_2Label" />
                    </strong>
                    <span className={css.tipText}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip3_2Text" />
                    </span>
                  </div>
                </li>
                <li className={css.tipItem}>
                  <div className={css.tipContent}>
                    <strong className={css.tipLabel}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip3_3Label" />
                    </strong>
                    <span className={css.tipText}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip3_3Text" />
                    </span>
                  </div>
                </li>
              </ul>
            </div>

            {/* Section 4: Deliver Like a Pro */}
            <div className={css.section}>
              <h3 className={css.sectionTitle}>
                <FormattedMessage id="FreelancerOnboardingModal.section4Title" />
              </h3>
              <ul className={css.tipList}>
                <li className={css.tipItem}>
                  <div className={css.tipContent}>
                    <strong className={css.tipLabel}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip4_1Label" />
                    </strong>
                    <span className={css.tipText}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip4_1Text" />
                    </span>
                  </div>
                </li>
                <li className={css.tipItem}>
                  <div className={css.tipContent}>
                    <strong className={css.tipLabel}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip4_2Label" />
                    </strong>
                    <span className={css.tipText}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip4_2Text" />
                    </span>
                  </div>
                </li>
                <li className={css.tipItem}>
                  <div className={css.tipContent}>
                    <strong className={css.tipLabel}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip4_3Label" />
                    </strong>
                    <span className={css.tipText}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip4_3Text" />
                    </span>
                  </div>
                </li>
                <li className={css.tipItem}>
                  <div className={css.tipContent}>
                    <strong className={css.tipLabel}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip4_4Label" />
                    </strong>
                    <span className={css.tipText}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip4_4Text" />
                    </span>
                  </div>
                </li>
              </ul>
            </div>

            {/* Section 5: Think Long-Term */}
            <div className={css.section}>
              <h3 className={css.sectionTitle}>
                <FormattedMessage id="FreelancerOnboardingModal.section5Title" />
              </h3>
              <ul className={css.tipList}>
                <li className={css.tipItem}>
                  <div className={css.tipContent}>
                    <strong className={css.tipLabel}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip5_1Label" />
                    </strong>
                    <span className={css.tipText}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip5_1Text" />
                    </span>
                  </div>
                </li>
                <li className={css.tipItem}>
                  <div className={css.tipContent}>
                    <strong className={css.tipLabel}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip5_2Label" />
                    </strong>
                    <span className={css.tipText}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip5_2Text" />
                    </span>
                  </div>
                </li>
                <li className={css.tipItem}>
                  <div className={css.tipContent}>
                    <strong className={css.tipLabel}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip5_3Label" />
                    </strong>
                    <span className={css.tipText}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip5_3Text" />
                    </span>
                  </div>
                </li>
                <li className={css.tipItem}>
                  <div className={css.tipContent}>
                    <strong className={css.tipLabel}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip5_4Label" />
                    </strong>
                    <span className={css.tipText}>
                      <FormattedMessage id="FreelancerOnboardingModal.tip5_4Text" />
                    </span>
                  </div>
                </li>
              </ul>
            </div>

            {/* Closing Message */}
            <div className={css.closingMessage}>
              <p>
                <FormattedMessage id="FreelancerOnboardingModal.closingMessage" />
              </p>
            </div>
          </div>

          {/* Footer with checkbox and close button */}
          <div className={css.modalFooter}>
            <label className={css.checkboxLabel}>
              <input
                type="checkbox"
                checked={dontShowAgain}
                onChange={this.handleCheckboxChange}
                className={css.checkbox}
              />
              <span className={css.checkboxText}>
                <FormattedMessage id="FreelancerOnboardingModal.dontShowAgain" />
              </span>
            </label>
            <PrimaryButton onClick={this.handleClose} className={css.closeButton}>
              <FormattedMessage id="FreelancerOnboardingModal.closeButton" />
            </PrimaryButton>
          </div>
        </div>
      </Modal>
    );
  }
}

FreelancerOnboardingModal.defaultProps = {
  onDismissPermanently: null,
};

FreelancerOnboardingModal.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  onManageDisableScrolling: func.isRequired,
  onDismissPermanently: func,
  intl: intlShape.isRequired,
};

export default injectIntl(FreelancerOnboardingModal);
